import { Button } from "primereact/button"
import { useContext } from "react"
import { GpraContext } from "../../../context/gpraContext"
import navigationLabels from "./navigationLabels"
import "../NavigationBar/navigationBar.css"
import { useNavigate } from "react-router-dom"
import ROUTES from "../../../components/Routes/routesContants"

const NavigationBarItem = ({ item, options }) => {
  const {
    interviewType,
    handleActiveIndex,
    sectionsCompleted,
    administrativeInterview,
    sections,
  } = useContext(GpraContext)
  const navigate = useNavigate()
  const getIndex = (label) => {
    switch (label) {
      case navigationLabels.recordMgmt:
        return 1
      case navigationLabels.startInterview:
        return 1
      case navigationLabels.demographics:
        return 2
      case navigationLabels.substanceUse1:
        return interviewType === "Intake" ? 3 : 2
      case navigationLabels.substanceUse2:
        return interviewType === "Intake" ? 4 : 3
      case navigationLabels.substanceUse3:
        return interviewType === "Intake" ? 5 : 4
      case navigationLabels.plannedServices1:
        return 6
      case navigationLabels.plannedServices2:
        return 7
      case navigationLabels.plannedServices3:
        return 8
      case navigationLabels.plannedServices4:
        return 9
      case navigationLabels.living:
        return interviewType === "Intake" ? 10 : 5
      case navigationLabels.education:
        return interviewType === "Intake" ? 11 : 6
      case navigationLabels.legal:
        return interviewType === "Intake" ? 12 : 7
      case navigationLabels.mental:
        return interviewType === "Intake" ? 13 : 8
      case navigationLabels.social:
        return interviewType === "Intake" ? 14 : 9
      case navigationLabels.program:
        return 10
      case navigationLabels.followUp:
        return !administrativeInterview ? 2 : 11
      case navigationLabels.discharge:
        return !administrativeInterview ? 2 : 11
      case navigationLabels.servicesReceived1:
        return !administrativeInterview ? 3 : 12
      case navigationLabels.servicesReceived2:
        return !administrativeInterview ? 4 : 13
      case navigationLabels.servicesReceived3:
        return !administrativeInterview ? 5 : 14
      case navigationLabels.servicesReceived4:
        return !administrativeInterview ? 6 : 15
      case navigationLabels.servicesReceived5:
        return !administrativeInterview ? 7 : 16
      case navigationLabels.summary:
        return interviewType === "Intake"
          ? 15
          : interviewType === "Discharge"
          ? !administrativeInterview
            ? 8
            : 17
          : !administrativeInterview
          ? 3
          : 12
      default:
        return 0
    }
  }
  const setStartRoutes = () => {
    if (interviewType === "FollowUp") {
      return ROUTES.GPRA_FOLLOWUP_START
    } else if (interviewType === "Discharge") {
      return ROUTES.GPRA_DISCHARGE_START
    }
  }
  const getRoute = (label) => {
    switch (label) {
      case navigationLabels.recordMgmt:
        return ROUTES.GPRA_RECORDMGMT
      case navigationLabels.startInterview:
        return setStartRoutes()
      case navigationLabels.demographics:
        return ROUTES.GPRA_DEMOGRAPHICS_INTAKE
      case navigationLabels.substanceUse1:
        return interviewType === "Intake"
          ? ROUTES.GPRA_SUBSTANCE_USE1_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_SUBSTANCE_USE1_DISCHARGE
          : ROUTES.GPRA_SUBSTANCE_USE1_FOLLOWUP
      case navigationLabels.substanceUse2:
        return interviewType === "Intake"
          ? ROUTES.GPRA_SUBSTANCE_USE2_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_SUBSTANCE_USE2_DISCHARGE
          : ROUTES.GPRA_SUBSTANCE_USE2_FOLLOWUP
      case navigationLabels.substanceUse3:
        return interviewType === "Intake"
          ? ROUTES.GPRA_SUBSTANCE_USE3_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_SUBSTANCE_USE3_DISCHARGE
          : ROUTES.GPRA_SUBSTANCE_USE3_FOLLOWUP
      case navigationLabels.plannedServices1:
        return interviewType === "Intake"
          ? ROUTES.GPRA_PLANNED_SERVICES1_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_PLANNED_SERVICES1_DISCHARGE
          : ROUTES.GPRA_PLANNED_SERVICES1_FOLLOWUP
      case navigationLabels.plannedServices2:
        return interviewType === "Intake"
          ? ROUTES.GPRA_PLANNED_SERVICES2_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_PLANNED_SERVICES2_DISCHARGE
          : ROUTES.GPRA_PLANNED_SERVICES2_FOLLOWUP
      case navigationLabels.plannedServices3:
        return interviewType === "Intake"
          ? ROUTES.GPRA_PLANNED_SERVICES3_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_PLANNED_SERVICES3_DISCHARGE
          : ROUTES.GPRA_PLANNED_SERVICES3_FOLLOWUP
      case navigationLabels.plannedServices4:
        return interviewType === "Intake"
          ? ROUTES.GPRA_PLANNED_SERVICES4_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_PLANNED_SERVICES4_DISCHARGE
          : ROUTES.GPRA_PLANNED_SERVICES4_FOLLOWUP
      case navigationLabels.living:
        return interviewType === "Intake"
          ? ROUTES.GPRA_FAMILY_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_FAMILY_DISCHARGE
          : ROUTES.GPRA_FAMILY_FOLLOWUP
      case navigationLabels.education:
        return interviewType === "Intake"
          ? ROUTES.GPRA_EDUCATION_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_EDUCATION_DISCHARGE
          : ROUTES.GPRA_EDUCATION_FOLLOWUP
      case navigationLabels.legal:
        return interviewType === "Intake"
          ? ROUTES.GPRA_LEGAL_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_LEGAL_DISCHARGE
          : ROUTES.GPRA_LEGAL_FOLLOWUP
      case navigationLabels.mental:
        return interviewType === "Intake"
          ? ROUTES.GPRA_MENTAL_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_MENTAL_DISCHARGE
          : ROUTES.GPRA_MENTAL_FOLLOWUP
      case navigationLabels.social:
        return interviewType === "Intake"
          ? ROUTES.GPRA_SOCIAL_INTAKE
          : interviewType.discharge
          ? ROUTES.GPRA_SOCIAL_DISCHARGE
          : ROUTES.GPRA_SOCIAL_FOLLOWUP
      case navigationLabels.program:
        return interviewType === "Discharge"
          ? ROUTES.GPRA_PROGRAM_QUESTIONS_DISCHARGE
          : ROUTES.GPRA_PROGRAM_QUESTIONS_FOLLOWUP
      case navigationLabels.followUp:
        return ROUTES.GPRA_FOLLOWUP_FOLLOWUP
      case navigationLabels.discharge:
        return ROUTES.GPRA_DISCHARGE_DISCHARGE
      case navigationLabels.servicesReceived1:
        return ROUTES.GPRA_SERVICESRECEIVED1_DISCHARGE
      case navigationLabels.servicesReceived2:
        return ROUTES.GPRA_SERVICESRECEIVED2_DISCHARGE
      case navigationLabels.servicesReceived3:
        return ROUTES.GPRA_SERVICESRECEIVED3_DISCHARGE
      case navigationLabels.servicesReceived4:
        return ROUTES.GPRA_SERVICESRECEIVED4_DISCHARGE
      case navigationLabels.servicesReceived5:
        return ROUTES.GPRA_SERVICESRECEIVED5_DISCHARGE
      case navigationLabels.summary:
        return interviewType === "Intake"
          ? ROUTES.GPRA_SUMMARY_INTAKE
          : interviewType === "Discharge"
          ? ROUTES.GPRA_SUMMARY_DISCHARGE
          : ROUTES.GPRA_SUMMARY_FOLLOWUP
      default:
        return 0
    }
  }
  const setNavigationItem = (section) => {
    const index = sections.findIndex((s) => {
      return s.section === section
    })
    handleActiveIndex(index)
  }
  const completed = (label) => {
    switch (label) {
      case navigationLabels.recordMgmt:
        return sectionsCompleted?.recordMgmt
      case navigationLabels.startInterview:
        return sectionsCompleted?.startInterview
      case navigationLabels.demographics:
        return sectionsCompleted?.demographics
      case navigationLabels.substanceUse1:
        return sectionsCompleted?.substanceUse1
      case navigationLabels.substanceUse2:
        return sectionsCompleted?.substanceUse2
      case navigationLabels.substanceUse3:
        return sectionsCompleted?.substanceUse3
      case navigationLabels.plannedServices1:
        return sectionsCompleted?.plannedServices1
      case navigationLabels.plannedServices2:
        return sectionsCompleted?.plannedServices2
      case navigationLabels.plannedServices3:
        return sectionsCompleted?.plannedServices3
      case navigationLabels.plannedServices4:
        return sectionsCompleted?.plannedServices4
      case navigationLabels.living:
        return sectionsCompleted?.family
      case navigationLabels.education:
        return sectionsCompleted?.education
      case navigationLabels.legal:
        return sectionsCompleted?.legal
      case navigationLabels.mental:
        return sectionsCompleted?.mental
      case navigationLabels.social:
        return sectionsCompleted?.social
      case navigationLabels.program:
        return sectionsCompleted?.program
      case navigationLabels.followUp:
        return sectionsCompleted?.followUp
      case navigationLabels.discharge:
        return sectionsCompleted?.discharge
      case navigationLabels.servicesReceived1:
        return sectionsCompleted?.servicesReceived1
      case navigationLabels.servicesReceived2:
        return sectionsCompleted?.servicesReceived2
      case navigationLabels.servicesReceived3:
        return sectionsCompleted?.servicesReceived3
      case navigationLabels.servicesReceived4:
        return sectionsCompleted?.servicesReceived4
      case navigationLabels.servicesReceived5:
        return sectionsCompleted?.servicesReceived5
      default:
        return false
    }
  }
  const getSectionIndex = (section) => {
    return sections.map((s) => s.section).indexOf(section)
  }
  const getClass = (label, activeIndex, successClassName, defaultClassName) => {
    if (completed(label)) {
      if (getSectionIndex(item.section) !== activeIndex) {
        return successClassName
      }
    }
    return defaultClassName
  }
  return (
    <div className={options.className}>
      <Button
        type="button"
        label={getIndex(item.label)}
        tooltip={item.label}
        tooltipOptions={{
          position: "bottom",
          mouseTrack: true,
          mouseTrackTop: 15,
          className: getClass(
            item.label,
            options.props.activeIndex,
            "success-tooltip",
            "custom-tooltip"
          ),
        }}
        className={getClass(
          item.label,
          options.props.activeIndex,
          "completed-section",
          options.numberClassName
        )}
        onClick={() => {
          setNavigationItem(item.section)
          navigate(getRoute(item.label))
        }}
      />
    </div>
  )
}
export default NavigationBarItem
